import _Toast from "@kibt/meta-ui/es/toast";
import _Loading from "@kibt/meta-ui/es/loading";
import _Popup from "@kibt/meta-ui/es/popup";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { defineComponent, ref, watch, nextTick } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import { getPlayerPhoto } from '../services';
import { useBridge } from '@/utils/yoda';
import InlinePhotos from './inline-photos.vue';
import { toProfile } from '@/utils/ikwai';
import { logger } from '@/utils/logger';
export default defineComponent({
  components: {
    MPopup: _Popup,
    InlinePhotos: InlinePhotos,
    MLoading: _Loading
  },
  props: {
    // 也用来控制弹窗弹出
    currentPopupUser: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    following: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close', 'change-follow-user'],
  setup: function setup(props, ctx) {
    var loading = ref(false);
    var photoList = ref([]);

    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
        var ret;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.next = 3;
                return getPlayerPhoto(userId);

              case 3:
                ret = _context.sent;
                loading.value = false;

                if (ret.result === 1 && ret.data) {
                  photoList.value = ret.data || [];
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    watch(function () {
      return props.currentPopupUser;
    }, function () {
      if (props.currentPopupUser) {
        fetchData(props.currentPopupUser.userId);
        logger.kwailog.sendShow({
          action: 'FOLLOW_BUTTON'
        });
      } else {
        nextTick(function () {
          photoList.value = [];
        });
      }
    }, {
      immediate: true
    });
    var doFollowing = false; // 关注或取消关注

    var changeFollow = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _props$currentPopupUs, _props$currentPopupUs2;

        var currentUserId, namespace, canuseRes, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!doFollowing) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                logger.kwailog.sendClick({
                  action: 'FOLLOW_BUTTON'
                });
                doFollowing = true;
                currentUserId = ((_props$currentPopupUs = props.currentPopupUser) === null || _props$currentPopupUs === void 0 ? void 0 : _props$currentPopupUs.userId) || 0;
                _context2.next = 7;
                return yoda.ready();

              case 7:
                namespace = 'business'; // 老版本兼容

                _context2.next = 10;
                return yoda.tool.canIUse({
                  namespace: namespace,
                  name: 'changeFollowStatus'
                });

              case 10:
                canuseRes = _context2.sent;

                if (!canuseRes.canUse) {
                  namespace = 'bussiness';
                }

                _context2.next = 14;
                return useBridge(namespace, 'changeFollowStatus', {
                  toFollow: !props.following,
                  toUid: (_props$currentPopupUs2 = props.currentPopupUser) === null || _props$currentPopupUs2 === void 0 ? void 0 : _props$currentPopupUs2.userId.toString()
                });

              case 14:
                res = _context2.sent;
                doFollowing = false;

                if (res.result === 1) {
                  _Toast.show({
                    text: props.following ? 'Deixou de seguir' // 已取消关注
                    : 'Sucesso'
                  });

                  ctx.emit('change-follow-user', currentUserId, !props.following);
                } else {
                  _Toast.show({
                    // 这里为true，说明用户已关注，想取消但失败了
                    text: 'Ocorreu um erro, tenta de novo'
                  });
                }

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function changeFollow() {
        return _ref2.apply(this, arguments);
      };
    }();

    return {
      changeFollow: changeFollow,
      loading: loading,
      photoList: photoList,
      toProfile: toProfile
    };
  }
});